import React from "react";
import { AlertTriangle, GitMerge } from "lucide-react";
import ModalShell from "../ModalShell";
import { deptName } from "../../utils/names";
import ReusableDropdown from "../../../../components/ReusableDropdown";

const MergeModal = ({ styles, t, language, theme, busy, departments, selectedIds, targetId, setTargetId, onClose, onConfirm }) => {
  const selected = [...selectedIds]
    .map((id) => departments.find((d) => d.id === id))
    .filter(Boolean);
  const canMerge = !busy && targetId;

  return (
    <ModalShell
      styles={styles}
      t={t}
      busy={busy}
      onClose={onClose}
      title={t.mergeTitle}
      subtitle={t.selectedCount(selected.length)}
      footer={
        <>
          <button type="button" style={styles.btnSecondary(busy)} disabled={busy} onClick={onClose}>{t.cancel}</button>
          <button type="button" style={styles.btnDanger(!canMerge)} disabled={!canMerge} onClick={onConfirm}>
            <GitMerge size={16} />{t.confirmMerge}
          </button>
        </>
      }
    >
      <div style={{ ...styles.notice("warning"), marginBottom: "16px" }}>
        <AlertTriangle size={16} style={{ flexShrink: 0, marginTop: "3px" }} />
        <span>{t.mergeWarning}</span>
      </div>
      <div style={styles.field}>
        <label style={styles.label} htmlFor="dept-merge-target">{t.mergeInto}</label>
        <ReusableDropdown
          id="dept-merge-target"
          items={selected}
          value={targetId}
          onChange={(value) => setTargetId(String(value))}
          getItemKey={(d) => d.id}
          getItemLabel={(d) => `${deptName(d, language)} (${t.membersCount(d._count?.employees ?? 0)})`}
          searchable={selected.length > 7}
          theme={theme}
          language={language}
        />
      </div>
      <div style={styles.label}>{t.mergeSources}</div>
      <div style={styles.chipList}>
        {selected.filter((d) => String(d.id) !== String(targetId)).map((d) => (
          <span key={d.id} style={styles.chip}><span style={styles.chipText}>{deptName(d, language)}</span></span>
        ))}
      </div>
    </ModalShell>
  );
};

export default MergeModal;
